import { render, staticRenderFns } from "./StrategyTemplate.vue?vue&type=template&id=4c1490a6&scoped=true&"
import script from "./StrategyTemplate.vue?vue&type=script&lang=ts&"
export * from "./StrategyTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./StrategyTemplate.vue?vue&type=style&index=0&id=4c1490a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1490a6",
  null
  
)

export default component.exports